import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.382 3.44a8.333 8.333 0 106.664 13.894M11.809 3.498c-1.956 2.4-3.587 6.173-2.19 9.166 1.402 3.01 5.47 4.414 8.583 4.44" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);